module.exports = __webpack_public_path__ + "static/img/more.6d5e9d5b.png";